export default {
  pos: getState("POS"),
  posId: getState("POS_ID"),
  posSave: getState("POS_SAVE"),
  loading: false,
  modalAddCustomer: false,
  params: {},
  itemPos: {}
}

function getState(key) {
  return JSON.parse(localStorage.getItem(key))
}
